import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { ComponentIds, HierarchyUtils, OutlinedComponent, SelectedComponent, } from "@inter-ikea-core/core";
import { COMPONENT_IDS } from "@inter-ikea-storagetwo/range";
/**
 * Temp system that handles some outline/selection bugs that can appear with undo/redo
 */
export default class UndoRedoOutlineSystem extends SystemBase {
    constructor(core) {
        super(ComponentIds.UPDATED_FROM_SNAPSHOT_EVENT_COMPONENT_ID);
        this.core = core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "UndoRedoOutlineSystem";
    }
    onRemoveComponent(_entity, _oldComponent) {
        var _a;
        const { entityStateBeforeLoadingSnapshot } = _oldComponent;
        // If mounting rail, re-apply selected if entity was selected prior to undo/redo
        _entity.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT) &&
            (entityStateBeforeLoadingSnapshot === null || entityStateBeforeLoadingSnapshot === void 0 ? void 0 : entityStateBeforeLoadingSnapshot.hasComponent(ComponentIds.SELECTED_COMPONENT_ID)) &&
            _entity.addComponent(new SelectedComponent());
        if (_entity.hasComponent(COMPONENT_IDS.UPRIGHT_COMPONENT)) {
            const isCurrentlyParent = HierarchyUtils.children(_entity).find((e) => e.hasComponent(COMPONENT_IDS.MOUNTING_RAIL_COMPONENT));
            const wasPreviouslyParent = entityStateBeforeLoadingSnapshot === null || entityStateBeforeLoadingSnapshot === void 0 ? void 0 : entityStateBeforeLoadingSnapshot.hasComponent(ComponentIds.PARENT_COMPONENT_ID);
            const parentIsSelected = (_a = HierarchyUtils.parent(_entity)) === null || _a === void 0 ? void 0 : _a.hasComponent(ComponentIds.SELECTED_COMPONENT_ID);
            parentIsSelected && _entity.addComponent(new OutlinedComponent());
            // If an upright was previously parent, but no longer, that means
            // a section to the right of it was removed with undo/redo.
            // If uprights parent is not selected, remove outline.
            if (!isCurrentlyParent && wasPreviouslyParent && !parentIsSelected) {
                _entity.addComponent(new OutlinedComponent());
                _entity.removeComponent(ComponentIds.OUTLINED_COMPONENT_ID);
            }
        }
    }
}
